// Booking notes carry allergy information as free text staff typed in — everything from
// "prawn allergy" to "Allergies: nuts, sesame, milk, egg" to "no allergies". The card used
// to try to parse this into individual allergen words for a compact chip: the regex
// backtracked onto "allergy" itself ("prawn allergy" → a chip reading "Y"), it capped at
// three words so a fourth allergen silently vanished from the card, "no allergies" and
// "Allergies - none" produced their own nonsense chips, and the same regex stripped the
// whole "allergy clause" out of the resting-row hint — taking the rest of a multi-allergen
// note down with it.
//
// A kitchen reading a mis-summarised or truncated allergy note is a safety issue, not a
// cosmetic one, so this doesn't try to be clever about it. It only flags that an allergy
// was *mentioned* at all — no negation handling, no word extraction, no "no allergies"
// special case, no fixed allergen list (the old one missed molluscs and lupin, two of the
// UK's 14, and never could be complete) — and leaves the actual words to the person
// reading the card. That means a bare allergen name with no "allergy"/"allergic" wording
// ("Peanuts - severe") isn't flagged; staff writing the overwhelmingly common phrasing
// ("peanut allergy") are covered, and a false negative there is a training question, not
// a parser one. A staff member glancing at "no allergies" next to the chip loses half a
// second; an algorithm guessing wrong about a real allergy doesn't get a second chance.

const ALLERGY_MENTION_RE = /allerg(?:y|ies|ic)\b/i;

/** True if any of `texts` mentions an allergy at all. */
export function hasAllergyMention(...texts) {
  return texts.some((t) => t && ALLERGY_MENTION_RE.test(t));
}

/** The resting-row hint: the note, trimmed, verbatim — never summarised or stripped, so
 * nothing in it can silently disappear. */
export function noteHint(text) {
  return (text || '').trim();
}
